import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import blood1 from './images/blood1.jpg';
import chat1 from './images/chat1.png';
import chat2 from './images/chat2.png';
import mush3 from './images/mush3.png';
import cymarket from './images/CYMARKET.png';
import gem from './images/GEM.png';
import alicha from './images/alicha.jpg';
import ackRetreat from './images/ACK_kiambu_Retreat-Recovered.png';
import acktalent from './images/Acktalent1.png';
import pcea from './images/PCEA.png';
import mtlongonot from './images/mtlongonot.png';
import graduation from './images/graduation.png';
import adeguate from './images/adeguate safaris1.png';
import charity from './images/charityevent0001.png';
import ackKesha from './images/ACK Kesha13.png';
import lizfinal from './images/lizfinal.png';
import ggi from './images/GGI.png';
import ccpy from './images/ccpy.png';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.15, ease: 'easeOut' },
  }),
};

const webProjects = [
  {
    num: '01',
    type: 'Full Website',
    title: 'Mush Tech Solution',
    desc: 'Corporate website for a Nairobi-based advanced security and IT services company. Features service listings, product gallery, WhatsApp CTA, and contact integration.',
    tech: ['HTML/CSS', 'JavaScript', 'Responsive', 'WhatsApp API'],
    url: 'https://mushtechsolution-website.vercel.app/',
    color: '#9333ea',
  },
  
  {
    num: '02',
    type: 'Full Website',
    title: 'Saferon Systems Limited',
    desc: 'Corporate site for a 30+ year veteran in electronic security and IT solutions in Nairobi. Built to reflect institutional trust and extensive service offerings.',
    tech: ['HTML/CSS', 'Responsive', 'Multi-section', 'Vercel'],
    url: 'https://saferon-systems-limited.vercel.app/',
    color: '#2563eb',
  },
];

const landingPages = [
  {
    num: '03',
    type: 'Landing Page',
    title: 'LUXURE — Black November Drop',
    desc: 'High-converting luxury fashion landing page with countdown timer, product showcase, and flash sale mechanics for a limited drop campaign.',
    tech: ['HTML/CSS/JS', 'Countdown Timer', 'E-commerce UX', 'Conversion Optimized'],
    url: 'https://luxury-landing-page-teal.vercel.app/',
    color: '#7c3aed',
  },
  {
    num: '04',
    type: 'Landing Page',
    title: 'TechDeals — Dell XPS 13 Product Page',
    desc: 'Single-product sales landing page for the Dell XPS 13 9380. Clean spec breakdown, trust signals, and direct purchase CTA optimized for conversions.',
    tech: ['HTML/CSS/JS', 'Product Page', 'Sales Focused', 'Mobile-Ready'],
    url: 'https://tech-deals-alpha.vercel.app/',
    color: '#3b82f6',
  },
];

const previousProjects = [
  {
    id: 0,
    title: 'Full Stack Web Apps',
    category: 'Frontend + Backend',
    icon: '🌐',
    color: 'from-cyan-500 to-blue-600',
    desc: 'Blood Management System that tracks donations and schedules donors, Property Management System with AI chatbot for customer support, and an Emergency Response System for rapid incident reporting — all built with React and Django/Node.js.',
    tags: ['React', 'Node.js', 'Django', 'MySQL'],
    images: [blood1, chat1, chat2],
  },
  {
    id: 1,
    title: 'Graphic Design Portfolio',
    category: 'Graphic Design',
    icon: '🎨',
    color: 'from-pink-500 to-rose-600',
    desc: 'Branding and marketing visuals including posters, flyers, and banners for churches, businesses and events across Nairobi.',
    tags: ['Adobe PS', 'Canva', 'Branding', 'Print'],
    images: [mush3, cymarket, gem, alicha, ackRetreat, acktalent, pcea, mtlongonot, graduation, adeguate, charity, ackKesha, lizfinal, ggi, ccpy],
  },
];

const LiveProjectCard = ({ project, index }) => {
  return (
    <motion.div
      variants={fadeUp}
      custom={index}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="group relative p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06] hover:border-white/20 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
    >
      <div
        className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl transition-all duration-300"
        style={{ background: `linear-gradient(90deg, transparent, ${project.color}, transparent)` }}
      />

      <div className="flex items-start justify-between mb-4">
        <div>
          <span
            className="font-mono text-xs font-bold"
            style={{ color: project.color }}
          >
            {project.num}
          </span>
          <span className="ml-2 text-xs text-slate-500 uppercase tracking-widest">
            {project.type}
          </span>
        </div>
        
         <a href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 rounded-lg bg-white/[0.04] border border-white/[0.08] flex items-center justify-center text-slate-400 hover:text-white hover:border-white/20 transition-all duration-200"
          title="Visit live site"
        >
          ↗
        </a>
      </div>

      <h3
        className="text-white font-bold text-lg mb-3 group-hover:transition-colors duration-300"
        style={{ color: 'white' }}
        onMouseEnter={(e) => e.target.style.color = project.color}
        onMouseLeave={(e) => e.target.style.color = 'white'}
      >
        {project.title}
      </h3>

      <p className="text-slate-400 text-sm leading-relaxed mb-5">
        {project.desc}
      </p>

      <div className="flex flex-wrap gap-2 mb-5">
        {project.tech.map((t) => (
          <span
            key={t}
            className="px-2.5 py-1 rounded-md text-xs font-mono border"
            style={{
              background: `${project.color}15`,
              borderColor: `${project.color}30`,
              color: project.color,
            }}
          >
            {t}
          </span>
        ))}
      </div>

      
        <a href={project.url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-sm font-semibold transition-colors duration-200"
        style={{ color: project.color }}
      >
        View Live Site
        <span className="group-hover:translate-x-1 transition-transform duration-200">→</span>
      </a>
    </motion.div>
  );
};

const PreviousProjectCard = ({ project, index }) => {
  const [activeImg, setActiveImg] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  const next = () => setActiveImg((p) => (p + 1) % project.images.length);
  const prev = () => setActiveImg((p) => (p - 1 + project.images.length) % project.images.length);

  return (
    <>
      <motion.div
        variants={fadeUp}
        custom={index}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="group rounded-2xl bg-white/[0.02] border border-white/[0.06] hover:border-cyan-500/20 overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/5"
      >
        <div className="relative overflow-hidden bg-[#0d1427]"
  style={{ height: project.category === 'Graphic Design' ? '320px' : '208px' }}
>
  <img
    src={project.images[activeImg]}
    alt={project.title}
    className="w-full h-full transition-all duration-500 group-hover:scale-105 cursor-zoom-in"
    style={{ objectFit: project.category === 'Graphic Design' ? 'contain' : 'cover' }}
    onClick={() => setLightbox(true)}
  />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1e] via-transparent to-transparent opacity-60" />

          <div className="absolute top-3 left-3">
            <span className={`px-3 py-1 rounded-full text-xs font-bold text-white bg-gradient-to-r ${project.color}`}>
              {project.category}
            </span>
          </div>

          <div className="absolute top-3 right-3 px-2 py-1 rounded-full bg-black/50 text-white text-xs font-mono">
            {activeImg + 1}/{project.images.length}
          </div>

          {project.images.length > 1 && (
            <>
              <button
                onClick={(e) => { e.stopPropagation(); prev(); }}
                className="absolute left-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-black/50 hover:bg-cyan-500 text-white flex items-center justify-center transition-all duration-200 opacity-0 group-hover:opacity-100 text-lg"
              >
                ‹
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); next(); }}
                className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-black/50 hover:bg-cyan-500 text-white flex items-center justify-center transition-all duration-200 opacity-0 group-hover:opacity-100 text-lg"
              >
                ›
              </button>
            </>
          )}

          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {project.images.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveImg(i)}
                className={`rounded-full transition-all duration-200 ${activeImg === i ? 'w-4 h-1.5 bg-cyan-400' : 'w-1.5 h-1.5 bg-white/40'}`}
              />
            ))}
          </div>
        </div>

        <div className="p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xl">{project.icon}</span>
            <h3 className="text-white font-bold group-hover:text-cyan-400 transition-colors">
              {project.title}
            </h3>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed mb-4">{project.desc}</p>
          <div className="flex flex-wrap gap-2">
            {project.tags.map((tag) => (
              <span
                key={tag}
                className="px-2.5 py-1 rounded-md bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-mono"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </motion.div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
            onClick={() => setLightbox(false)}
          >
            <button
              onClick={() => setLightbox(false)}
              className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xl"
            >
              x
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); prev(); }}
              className="absolute left-6 w-10 h-10 rounded-full bg-white/10 hover:bg-cyan-500 text-white flex items-center justify-center text-2xl"
            >
              ‹
            </button>
            <motion.img
              key={activeImg}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              src={project.images[activeImg]}
              alt={project.title}
              className="max-w-4xl max-h-[80vh] w-full object-contain rounded-xl px-20"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={(e) => { e.stopPropagation(); next(); }}
              className="absolute right-6 w-10 h-10 rounded-full bg-white/10 hover:bg-cyan-500 text-white flex items-center justify-center text-2xl"
            >
              ›
            </button>
            <div className="absolute bottom-6 text-slate-400 text-sm font-mono">
              {activeImg + 1} / {project.images.length}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const Projects = () => {
  return (
    <div className="relative py-32 px-6 bg-[#0a0f1e] overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/40 to-transparent" />
      <div className="absolute bottom-20 left-0 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto">

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex items-center gap-4 mb-4"
        >
          <span className="font-mono text-cyan-400 text-sm">04.</span>
          <h2 className="text-3xl md:text-4xl font-black text-white">Projects</h2>
          <div className="flex-1 h-px bg-gradient-to-r from-cyan-500/40 to-transparent" />
        </motion.div>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-slate-400 mb-16 max-w-xl"
        >
          Live websites, web apps and design work built for real clients.
        </motion.p>

        {/* Live Projects */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
          <h3 className="text-white font-bold text-xl">Live Projects</h3>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {webProjects.map((p, i) => (
            <LiveProjectCard key={p.num} project={p} index={i} />
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-20">
          {landingPages.map((p, i) => (
            <LiveProjectCard key={p.num} project={p} index={i} />
          ))}
        </div>

        {/* Previous Projects */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-slate-400" />
          <h3 className="text-white font-bold text-xl">Previous Projects</h3>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {previousProjects.map((p, i) => (
            <PreviousProjectCard key={p.id} project={p} index={i} />
          ))}
        </div>

      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent" />
    </div>
  );
};

export default Projects;